{
    "administration": "الإدارة",
    "ai": "إعدادات الذكاء الاصطناعي",
    "ai_usage": "استخدام الذكاء الاصطناعي",
    "alerts": "التنبيهات",
    "api_docs": "مرجع الواجهات",
    "audit": "سجل التدقيق",
    "branding": "الهوية البصرية",
    "cc_chatbot": "المحادث الآلي",
    "cc_configuration": "قوائم الانتظار والوكلاء",
    "cc_console": "شاشة الوكيل",
    "cc_ivr": "مصمّم الرد الصوتي",
    "cc_licensing": "تراخيص مركز الاتصال",
    "cc_reporting": "تقارير مركز الاتصال",
    "cc_wallboard": "لوحة المتابعة",
    "close_menu": "إغلاق القائمة",
    "collapse_sidebar": "طي الشريط الجانبي",
    "command_palette": "لوحة الأوامر",
    "complaint_configuration": "قواعد الشكاوى",
    "complaints": "الشكاوى",
    "compliance": "مصفوفة الامتثال",
    "contact_centre": "مركز الاتصال",
    "customers": "العملاء",
    "dashboard": "لوحة المعلومات",
    "demo": "التحكم بالعرض",
    "events": "أحداث النواة",
    "expand_sidebar": "توسيع الشريط الجانبي",
    "guide": "دليل المستخدم",
    "health": "حالة النظام",
    "import": "الاستيراد",
    "integrations": "التكاملات",
    "integrations_health": "حالة التكاملات",
    "integrations_keys": "مفاتيح الواجهة",
    "integrations_simulators": "محاكيات التكامل",
    "integrations_webhooks": "الويب هوك",
    "knowledge": "قاعدة المعرفة",
    "main_navigation": "التنقل الرئيسي",
    "mark_all_read": "تعليم الكل كمقروء",
    "measurement": "تجربة العملاء",
    "mex_actions": "إجراءات التحسين",
    "mex_dashboard": "تجربة العملاء",
    "mex_distributions": "إرسال الاستبيانات",
    "mex_journeys": "رحلات الاستبيانات",
    "mex_simulators": "قنوات الاستبيان",
    "mex_surveys": "الاستبيانات",
    "mex_verbatims": "آراء العملاء",
    "no_alerts": "لا توجد إشعارات جديدة",
    "notifications": "الإشعارات",
    "open_menu": "فتح القائمة",
    "operations": "العمليات",
    "profile": "ملفي الشخصي",
    "queue": "طوابير الفروع",
    "queue_appointments": "المواعيد",
    "queue_configuration": "الخدمات والشبابيك",
    "queue_hardware": "أجهزة الفروع",
    "queue_simulator": "محاكي الفرع",
    "reports": "التقارير",
    "reports_builder": "منشئ التقارير",
    "reports_executive": "لوحة الإدارة التنفيذية",
    "reports_runs": "سجل التقارير",
    "reports_schedules": "التقارير المجدولة",
    "search_placeholder": "ابحث عن عملاء أو شكاوى أو تذاكر…",
    "security": "الأمان",
    "segments": "الشرائح",
    "settings": "الإعدادات",
    "showcase": "ابدأ من هنا",
    "skip_to_content": "الانتقال إلى المحتوى",
    "user_menu": "قائمة الحساب",
    "users": "المستخدمون والأدوار",
    "view_layouts": "تخطيطات الشاشات"
}
